import { FooterSectionProps } from "@/src/layout/footer/v1";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaSquareInstagram,
  FaLinkedin,
} from "react-icons/fa6";

export const footerSectionData_ar: FooterSectionProps = {
  about: {
    description:
      "أهلا بكم في عالم أنتم مركزه. بفضل فريق كبير من المهندسين المحترفين والمتخصصين المعتمدين، نحن وجهتكم المثلى لتقديم حلول شاملة لمجموعة واسعة من خدمات تكنولوجيا المعلومات، من تصميم وتنفيذ البنى التحتية إلى تطوير البرمجيات وحلول السحابة، نقدم لكم الدعم الكامل والمبتكر لتلبية جميع احتياجاتكم التقنية.",
    socialLinks: [
      {
        icon: <FaLinkedin />,
        href: "https://www.linkedin.com/company/smartoasisoffical/",
      },
      {
        icon: <FaFacebookF />,
        href: "https://www.facebook.com/smartoasis.official",
      },
      {
        icon: <FaInstagram />,
        href: "https://www.instagram.com/smartoasis.official",
      },
    ],
  },
  columnOne: {
    title: "الحلول",
    links: [
      {
        id: 1,
        label: "الاتصالات السلكية واللاسلكية",
        href: "/ar/solutions",
        openNewTab: false,
      },
      {
        id: 2,
        label: "مراكز البيانات والاستضافة",
        href: "/ar/solutions",
        openNewTab: false,
      },
      {
        id: 3,
        label: "تطوير البرمجيات",
        href: "/ar/solutions",
        openNewTab: false,
      },
      {
        id: 4,
        label: "حلول الأمن السيبراني",
        href: "/ar/solutions",
        openNewTab: false,
      },
      {
        id: 5,
        label: "خدمات اختبار الاختراق",
        href: "/ar/solutions",
        openNewTab: false,
      },
      {
        id: 6,
        label: "حلول الأدوات والتحكم (I&C)",
        href: "/ar/solutions",
        openNewTab: false,
      },
      {
        id: 7,
        label: "حلول أنظمة الأمان",
        href: "/ar/solutions",
        openNewTab: false,
      },
      {
        id: 8,
        label: "حلول إنترنت الأشياء",
        href: "/ar/solutions",
        openNewTab: false,
      },
    ],
  },
  columnTwo: {
    title: "العناوين",
    location: "بغداد  - شارع مطار بغداد",
    mails: ["info@soc.iq"],
    phoneNumbers: ["(+964)785-0100-005"],
  },
  columnThree: {
    title: "الخدمات",
    links: [
      {
        label: "خدمات البنية التحتية لتكنولوجيا المعلومات",
        href: "/ar/services?id=1",
        openNewTab: false,
      },
      {
        label: "الخدمات المدارة لتكنولوجيا المعلومات",
        href: "/ar/services?id=2",
        openNewTab: false,
      },
      {
        label: "خدمات الأمان السيبراني",
        href: "/ar/services?id=3",
        openNewTab: false,
      },
      {
        label: "تطوير البرمجيات",
        href: "/ar/services?id=4",
        openNewTab: false,
      },
      {
        label: "خدمات التحول الرقمي",
        href: "/ar/services?id=5",
        openNewTab: false,
      },
      {
        label: "الشبكات والاتصالات",
        href: "/ar/services?id=6",
        openNewTab: false,
      },
      {
        label: "تحليلات البيانات والذكاء التجاري",
        href: "/ar/services?id=7",
        openNewTab: false,
      },
      {
        label: "خدمات الاستشارات والمشورة",
        href: "/ar/services?id=8",
        openNewTab: false,
      },
      {
        label: "التدريب والتعليم",
        href: "/ar/services?id=9",
        openNewTab: false,
      },
      {
        label: "خدمات الدعم والصيانة",
        href: "/ar/services?id=10",
        openNewTab: false,
      },
      {
        label: "حلول الحكومة الإلكترونية",
        href: "/ar/services?id=11",
        openNewTab: false,
      },
    ],
  },
  footerBottom: {
    copyrightText: "© جميع الحقوق محفوظة  | Soc.iq  2025  ",
  },
};
